import { render } from "./fbx-input.vue?vue&type=template&id=8e53c830&scoped=true"
import script from "./fbx-input.vue?vue&type=script&lang=js"
export * from "./fbx-input.vue?vue&type=script&lang=js"

import "./fbx-input.vue?vue&type=style&index=0&id=8e53c830&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e53c830"]])

export default __exports__